import { render, staticRenderFns } from "./ConsignmentInvoice.vue?vue&type=template&id=61d9ecb6"
import script from "./ConsignmentInvoice.vue?vue&type=script&lang=js"
export * from "./ConsignmentInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports